import { ShoppingCart, CheckCircle, FileText } from 'lucide-react';
import type { TemplateDefinition } from './types';

// Default colors here are picker fallbacks only. The real defaults at render
// time live in emails/store/_layout.ejs (Zero navy → black, black button) —
// when a merchant leaves brand colors unset, the layout falls back to those.
const ZERO_DEFAULTS = {
  brandColor:      '#2F6FAC',
  buttonColor:     '#2F6FAC',
  textColor:       '#111111',
  backgroundColor: '#FAFAFA',
};

export const TEMPLATE_DEFINITIONS: TemplateDefinition[] = [
  {
    type: 'cart-recovery',
    labelKey: 'emailEditor.template.cartRecovery',
    descriptionKey: 'emailEditor.templateDesc.cartRecovery',
    icon: ShoppingCart,
    defaultColors: { ...ZERO_DEFAULTS },
    // cart-recovery shows greeting (via customerName), body, and a CTA.
    // greeting field isn't used by the template (the "مرحباً X" is auto-built
    // from customerName), so we hide it.
    contentFields: ['subject', 'bodyHtml', 'cta'],
    defaultSubjectKey: 'emailEditor.defaults.cartRecoverySubject',
    defaultGreetingKey: 'emailEditor.defaults.greeting',
    defaultCtaKey: 'emailEditor.defaults.cartRecoveryCta',
    defaultBodyKey: 'emailEditor.defaults.cartRecoveryBody',
  },
  {
    type: 'order-confirmation',
    labelKey: 'emailEditor.template.orderConfirmation',
    descriptionKey: 'emailEditor.templateDesc.orderConfirmation',
    icon: CheckCircle,
    defaultColors: { ...ZERO_DEFAULTS },
    // Order confirmation is data-driven (success icon, order info, items list,
    // totals). Only subject + an optional intro paragraph (bodyHtml) make sense.
    // Greeting auto-renders from customerName; CTA is hardcoded to track-order.
    contentFields: ['subject', 'bodyHtml'],
    defaultSubjectKey: 'emailEditor.defaults.orderConfirmationSubject',
    defaultGreetingKey: 'emailEditor.defaults.greeting',
    defaultCtaKey: 'emailEditor.defaults.orderConfirmationCta',
    defaultBodyKey: 'emailEditor.defaults.orderConfirmationBody',
  },
  {
    type: 'generic',
    labelKey: 'emailEditor.template.generic',
    descriptionKey: 'emailEditor.templateDesc.generic',
    icon: FileText,
    defaultColors: { ...ZERO_DEFAULTS },
    // Generic is the only template whose layout is driven entirely by editor
    // input — every field maps directly.
    contentFields: ['subject', 'greeting', 'bodyHtml', 'cta'],
    defaultSubjectKey: 'emailEditor.defaults.genericSubject',
    defaultGreetingKey: 'emailEditor.defaults.greeting',
    defaultCtaKey: 'emailEditor.defaults.genericCta',
    defaultBodyKey: 'emailEditor.defaults.genericBody',
  },
];
